<div class="fleetExportAsset">
  <header class="fleetExportAssetHeader" (click)="toggleAsset()">
    @if (ppSelectable) {
      <pp-checkbox
        ppType="solid"
        [ppChecked]="ppExportAsset.selected"
      ></pp-checkbox>
    }

    {{ ppExportAsset.name }}
  </header>

  @for (dashlet of ppExportAsset.assets; track dashlet) {
    <pp-fleet-export-page-dashlet
      [ppExportDashlet]="dashlet"
      [ppDisabled]="!ppExportAsset.selected"
      (ppExportDashletChange)="onDashletToggle()"
    ></pp-fleet-export-page-dashlet>
  }
</div>
